<template>
  <v-app>
    <v-main class="h-100">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import queryString from 'query-string'
import config from '@/config'
export default {
  name: 'App',
  async mounted() {
    // if (config.pageid == "102549712095297") {
    //   window.location.replace(`${config.domain}${this.$route.fullPath}`);
    // }
    var vm = this
    await vm.queryinit()
    // vm.init();
  },
  components: {
    query() {
      return this.$store.state.query
    },
    view() {
      return this.$store.state.query.view
    }
  },
  methods: {
    init() {
      var vm = this
      return new Promise(async resolve => {
        // Production
        var liffid = '1656443757-2e5arpda' //prod next
        // var liffid = '1656443757-A1Dg53mg' //prod local next

        // var liffid = "1656355405-9VlW7D3W"; //prod

        // Local
        // var liffid = '1656355405-2ZdNrbqN' // enpoint dev local
        // UAT
        var liffid = '1656355405-yMVXo4bX' //enpoint dev

        if (this.query.apptype == 'line') {
          await this.initializeLiff(liffid)
          // console.log("id", this.$store.state.profile.userId + "__" + config.pageid);
          this.$store.state.userid = this.$store.state.profile.userId + '__' + config.pageid
          resolve()
        } else {
          this.$store.state.userid = this.query.userid
          window.extAsyncInit = function() {
            // the Messenger Extensions JS SDK is done loading
          }
          resolve()
        }
      })
    },
    async initializeLiff(myLiffId) {
      var vm = this
      var redirectUri = window.location.href
      try {
        await this.$liff.init({
          liffId: myLiffId
        })
        if (await this.$liff.isLoggedIn()) {
          this.$store.state.profile = await this.$liff.getProfile()
          vm.loading = false
        } else {
          await this.$liff.login({ redirectUri })
        }
      } catch (error) {
        // alert(error.message);
      }
    },
    queryinit() {
      var vm = this
      let tempParams = vm.$route.query['liff.state']
      if (tempParams && tempParams.includes('?')) {
        tempParams = tempParams.split('?')[1]
      }
      vm.$store.state.query = tempParams ? queryString.parse(tempParams) : vm.$route.query
      vm.init()
    }
  },

  data: () => ({
    //
  })
}
</script>
<style lang="css">
@import url('https://fonts.googleapis.com/css?family=Roboto:400,100,100italic,300,300ita‌​lic,400italic,500,500italic,700,700italic,900italic,900');
@import url('https://fonts.googleapis.com/css2?family=Prompt&display=swap');
@import '~bootstrap/dist/css/bootstrap.css';
body {
  font-family: 'Prompt', 'Roboto', sans-serif !important;
}
.v-application {
  font-family: 'Prompt', 'Roboto', sans-serif !important;
}
.paragraph {
  text-indent: 30px;
}
.paragraph-2 {
  text-indent: 20px;
  margin-left: 30px;
}
.nav-main {
  position: fixed !important;
  left: 0;
  right: 0;
  top: 0;
  height: 67px;
  z-index: 50;
}
.session-with-nav {
  margin-top: 70px !important;
}
.main-btn {
  border-radius: 20px !important;
  box-shadow: 16px 8px 18px rgba(33, 73, 198, 0.26),
    inset 14px 12px 13px -4px rgba(255, 255, 255, 0.23) !important;
}
.text-center {
  text-align: center;
}
.flex-all-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.text-gray {
  color: #817f7f;
}
.text-blue {
  color: rgb(35, 64, 154) !important;
}
.text-green {
  color: rgb(50, 168, 82) !important;
}
.bg-gray {
  background-color: #f3f3f3;
}
.rsu {
  font-family: 'rsu', sans-serif !important;
  font-size: 1.15rem;
}

.Montserrat {
  font-family: 'Montserrat', sans-serif !important;
}

.border-input {
  border: 1px solid #23409a !important;
  border-radius: 5px;
}
.bg-blue {
  background-color: #23409a !important;
}

.Kanit {
  font-family: 'Kanit', sans-serif !important;
}

.swal2-modal {
  font-family: 'Montserrat', 'Kanit', sans-serif !important;
}
.nav-regis {
  position: fixed;
  height: 67px;
  top: 0;
}
.bot-regis {
  position: fixed;
  height: 67px;
  bottom: 0;
  background-color: white;
}
.v-text-field__slot > input {
  padding-top: 12px !important;
}
.item-contact {
  background: radial-gradient(129.77% 129.77% at 48.82% -19.51%, #ffffff 35.11%, #ffffff 95.35%);
  border: 1px solid transparent;
  padding: 13px;
  border-radius: 15px;
  box-shadow: 1px 6px 16px 5px rgba(0, 0, 0, 0.06);
  -webkit-box-shadow: 1px 6px 16px 5px rgba(0, 0, 0, 0.06);
  -moz-box-shadow: 1px 6px 16px 5px rgba(0, 0, 0, 0.06);
}
.bot-regis-2 {
  position: fixed;
  height: 110px;
  bottom: 0;
  background-color: white;
}
.v-card--link:focus:before {
  opacity: 0;
}
.fs-12 {
  font-size: 12px !important;
}
.fs-13 {
  font-size: 13px !important;
}
.fs-14 {
  font-size: 14px !important;
}
.fs-15 {
  font-size: 15px !important;
}
.fs-16 {
  font-size: 16px !important;
}
.fs-17 {
  font-size: 17px !important;
}
.fs-18 {
  font-size: 18px !important;
}
.fs-19 {
  font-size: 19px !important;
}
.fs-20 {
  font-size: 20px !important;
}
.rounded-4 {
  border-radius: 0.4rem !important;
}
.rounded-5 {
  border-radius: 0.5rem !important;
}
.rounded-6 {
  border-radius: 0.6rem !important;
}
.rounded-7 {
  border-radius: 0.7rem !important;
}
.rounded-8 {
  border-radius: 0.8rem !important;
}
.rounded-9 {
  border-radius: 0.9rem !important;
}
.divider {
  height: 1px;
  background-color: #e0e0e0;
}
.divider-white {
  height: 1px;
  background-color: white;
}
.row-menu {
  padding: 12px 16px !important;
  font-weight: 500;
  font-size: 18px;
}
.row-menu-child {
  background-color: #f2f2f2;
  padding: 10px 30px !important;
  cursor: pointer;
  font-weight: 400;
  font-size: 15px;
}
.text-primary-2 {
  color: #3d56a5;
}
.icon-click::after {
  content: '>';
}
.after-account::after {
  color: #5c5c5c;
  font-size: 12px;
  content: ' (ทุกบัญชี)';
}
.v-input--selection-controls {
  margin-top: 0 !important;
  padding-top: 0 !important;
}
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.ele-shadow {
  top: 0;
  left: 0;
  position: relative;
  width: 100%;
  height: 3px;
  background: linear-gradient(180deg, rgba(113, 113, 113, 1) 0%, rgba(255, 255, 255, 1) 100%);
}
div.nm-color > div.v-input__control > div.v-input__slot > div > i.mdi-checkbox-marked {
  color: #007a47 !important;
}
.nm-color {
  color: #007a47 !important;
}
</style>
